import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { galleryProjects } from '../../data/gallery';
import { ui } from '../../data/ui';
import { buttonClass } from '../../utils/styles';
import { GalleryGrid } from '../GalleryGrid';
import { SectionHeading } from '../SectionHeading';
export function GalleryPreview() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white" aria-labelledby="gallery-heading" data-id="element-136" data-mp="1zfv8bycj14g3">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24" data-id="element-137" data-mp="1uk6b41nzbzmy">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-138" data-mp="2989fx7qad5a6">
          <SectionHeading id="gallery-heading" eyebrow={t({
          en: 'Before & after',
          es: 'Antes y después'
        })} title={t({
          en: 'Real Dallas projects, real results',
          es: 'Proyectos reales en Dallas, resultados reales'
        })} description={t({
          en: 'Every photo below is our own work, taken on site. Drag the handle to see the condition we started with.',
          es: 'Cada foto es de nuestro propio trabajo, tomada en sitio. Desliza el control para ver cómo estaba antes.'
        })} data-id="element-139" data-mp="24havbvy9ll14" />
          <Link to="/gallery" className={buttonClass('outline', 'md', 'shrink-0')} data-id="element-140" data-mp="16q3wxstxiri9">
            {t(ui.viewFullGallery)}
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="a0usu9lmcocg" />
          </Link>
        </div>

        <div className="mt-12" data-id="element-142" data-mp="eyecxq4zzvcb">
          <GalleryGrid projects={galleryProjects.slice(0, 3)} data-id="element-143" data-mp="ezfywpnjy28t" />
        </div>
      </div>
    </section>;
}